var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "notice-list flex-between" }, [
        _c(
          "div",
          {
            staticClass: "notice-item",
            class: {
              "can-view": _vm.isZbCanView,
              active: _vm.noticeType === _vm.noticeTypeMap.ZBGG,
            },
            on: {
              click: function ($event) {
                _vm.isZbCanView && _vm.selectNoticeType(_vm.noticeTypeMap.ZBGG)
              },
            },
          },
          [
            _vm.noticeType === "1"
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/招标公告1.png"),
                    alt: "",
                  },
                })
              : _vm.isZbCanView
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/招标公告2.png"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/招标公告3.png"),
                    alt: "",
                  },
                }),
            _c("span", [_vm._v("招标公告")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "notice-item cs-fb",
            class: {
              "can-view": _vm.isCqCanView,
              active: _vm.noticeType === _vm.noticeTypeMap.BGGG,
            },
            on: {
              click: function ($event) {
                _vm.isCqCanView && _vm.selectNoticeType(_vm.noticeTypeMap.BGGG)
              },
            },
          },
          [
            _vm.noticeType === "2"
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/澄清变更公告1.png"),
                    alt: "",
                  },
                })
              : _vm.isCqCanView
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/澄清变更公告2.png"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/澄清变更公告3.png"),
                    alt: "",
                  },
                }),
            _c("span", [_vm._v("澄清/变更公告")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "notice-item",
            class: {
              "can-view": _vm.isHxCanView,
              active: _vm.noticeType === _vm.noticeTypeMap.ZBHXRGS,
            },
            on: {
              click: function ($event) {
                _vm.isHxCanView &&
                  _vm.selectNoticeType(_vm.noticeTypeMap.ZBHXRGS)
              },
            },
          },
          [
            _vm.noticeType === "3"
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/中标候选人公示1.png"),
                    alt: "",
                  },
                })
              : _vm.isHxCanView
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/中标候选人公示2.png"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/中标候选人公示3.png"),
                    alt: "",
                  },
                }),
            _c("span", [_vm._v("候选人公示")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "notice-item",
            class: {
              "can-view": _vm.isLbCanView,
              active: _vm.noticeType === _vm.noticeTypeMap.ZBJG,
            },
            on: {
              click: function ($event) {
                _vm.isLbCanView && _vm.selectNoticeType(_vm.noticeTypeMap.ZBJG)
              },
            },
          },
          [
            _vm.noticeType === "4"
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/中标流标公告1.png"),
                    alt: "",
                  },
                })
              : _vm.isLbCanView
              ? _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/中标流标公告2.png"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "notice-img",
                  attrs: {
                    src: require("@/assets/images/xmxx/中标流标公告3.png"),
                    alt: "",
                  },
                }),
            _c("span", [_vm._v("结果公告")]),
          ]
        ),
      ]),
      _vm.detailList.length > 1
        ? _c(
            "el-table",
            {
              staticClass: "detail-table",
              attrs: {
                data: _vm.detailList,
                fit: "",
                "header-cell-style": _vm.headerCellStyle,
                "cell-style": _vm.cellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "项目名称", "min-width": "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "text-cut",
                              attrs: { title: scope.row.gonggaoTitle },
                            },
                            [_vm._v(_vm._s(scope.row.gonggaoTitle))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3797241240
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "gonggaoFbstartDateStr",
                  label: "公告日期",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "select-btn",
                              class: {
                                "is-active":
                                  row.infoid === _vm.detailInfo.infoid,
                              },
                              attrs: {
                                type: "primary",
                                plain: "",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeItem(row)
                                },
                              },
                            },
                            [_vm._v("选中查看")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1953202513
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "detail-content" }, [
        _c("div", { staticClass: "detail-content-header" }, [
          _c("p", { staticClass: "fs-20" }, [
            _vm._v(_vm._s(_vm.detailInfo.gonggaoTitle)),
          ]),
          _c("p", { staticClass: "color-999 mt-20" }, [
            _vm._v("发布时间：" + _vm._s(_vm.detailInfo.gonggaoFbstartDateStr)),
          ]),
        ]),
        _c("div", {
          staticClass: "detail-content-body",
          domProps: { innerHTML: _vm._s(_vm.detailInfo.gonggaoContent) },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }